import styled from "styled-components";

export const CheckBoxWrapper = styled.div`
  position: relative;
  display: flex;
`;

export const CheckBoxLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: 243px;
  height: 32px;
  border-radius: 24px;
  background: #f4f7fc;
  display: flex;
  align-items: center;
  cursor: pointer;
  @media (max-width: 1024px) {
    background: var(--bg-white);
  }
  &::after {
    content: "";
    display: block;
    border-radius: 24px;
    width: 122px;
    height: 28px;
    /* margin: 3px; */
    background: #6caeff;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.35);
    transition: 0.2s;
  }
  @media (max-width: 1024px) {
    width: calc(360px - 32px);
    height: 32px;
    &::after {
      content: "";
      width: 164px;
      height: 28px;
      /* margin: 6px; */
    }
  }
`;

export const CheckBox = styled.input`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  cursor: pointer;
  width: 243px;
  height: 32px;
  /* text-shadow: 0px 0px 5px rgba(0, 0, 0, 0.826); */

  &:checked + ${CheckBoxLabel} {
    &::after {
      content: "";
      display: block;
      border-radius: 24px;
      width: 122px;
      height: 28px;
      margin-left: 118px;
      box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.35);
      transition: 0.3s;
    }
  }
  @media (max-width: 1024px) {
    width: calc(360px - 32px);
    height: 32px;
    &:checked + ${CheckBoxLabel} {
      &::after {
        content: "";
        width: 170px;
        height: 28px;
        margin-left: 150px;
      }
    }
  }
`;

export const SwitchOptions = styled.span`
  position: absolute;
  direction: rtl;
  padding: 7px 15px;
  font-size: 12px;
  white-space: nowrap;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50%;
  height: 100%;
  color: var(--gray-100);
  color: #f6f8ff;
  &.active {
    color: var(--gray-500);
  }
  &:first-child {
    left: 0;
  }
  &:last-child {
    right: 0;
  }
`;
